import React from "react"
import PropTypes from "prop-types"
import CircularProgress from "material-ui/CircularProgress"
import baseTheme from "material-ui/styles/baseThemes/lightBaseTheme"
import getMuiTheme from "material-ui/styles/getMuiTheme"

const api = require("../../api")

const propTypes = {
    url: PropTypes.string,
    src: PropTypes.string,
    fixedHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    avatar: PropTypes.bool
}

export default class ImageLoader extends React.Component {
    constructor(props) {
        super()
        this.state = {
            showProgress: true,
            imageDisplay: false,
            imageData: ""
        }
    }

    getChildContext() {
        return { muiTheme: getMuiTheme(baseTheme) }
    }

    componentDidMount() {
        if (!this.props.url || this.props.url.length === 0) {
            api.loadImageData(this.props.src).then(
                function(result) {
                    this.setState({
                        showProgress: false,
                        imageDisplay: true,
                        imageData: "data:image/jpg;base64," + result.data
                    })
                }.bind(this)
            )
        } else {
            this.setState({
                showProgress: false,
                imageDisplay: true
            })
        }
    }

    render() {
        const avatarHeight = this.props.fixedHeight / 1.8

        return (
            <span className="image-loader ImageLoader">
                {this.state.showProgress && (
                    <span
                        style={
                            this.props.avatar
                                ? {
                                      textAlign: "center",
                                      width: "100%",
                                      paddingTop: 0
                                  }
                                : {
                                      textAlign: "center",
                                      width: "100%",
                                      paddingTop: 100
                                  }
                        }
                    >
                        <CircularProgress size={50} thickness={1} style={!this.props.avatar ? { height: this.props.fixedHeight } : { height: avatarHeight / 2 }} />
                    </span>
                )}
                <div
                    style={
                        this.props.avatar
                            ? {
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  height: avatarHeight,
                                  width: avatarHeight,
                                  position: "relative",
                                  zIndex: 10
                              }
                            : {
                                  height: this.props.fixedHeight,
                                  maxWidth: this.props.maxWidth,
                                  display: "inline"
                              }
                    }
                >
                    {this.state.imageDisplay && (
                        <img
                            style={
                                this.props.avatar
                                    ? {
                                          display: "inline",
                                          position: "absolute",
                                          height: this.props.fixedHeight,
                                          left: "-9999px",
                                          right: "-9999px",
                                          top: "-9999px",
                                          bottom: "-9999px",
                                          margin: "auto",
                                          zIndex: 9
                                      }
                                    : {
                                          display: "inline",
                                          height: this.props.fixedHeight,
                                          maxWidth: this.props.maxWidth
                                      }
                            }
                            src={this.props.url && this.props.url.length !== 0 ? this.props.url : this.state.imageData}
                        />
                    )}
                </div>
            </span>
        )
    }
}

ImageLoader.childContextTypes = {
    muiTheme: React.PropTypes.object.isRequired
}

ImageLoader.propTypes = propTypes
